"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invisible = exports.wrapper = void 0;

var react_1 = require("@emotion/react");

var wrapper = function wrapper(top, align) {
  return react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  ", ": 0;\n  border-radius: 4px;\n  box-shadow: 0 8px 16px 0 rgba(33, 37, 41, 0.15), 0 0 0 1px var(--gray-100),\n    0 1px 4px 0 rgba(0, 0, 0, 0.15);\n  background-color: var(--white);\n  visibility: visible;\n  opacity: 1;\n  transform: scale(1);\n  transform-origin: left top;\n  transition: transform 0.12s ease, opacity 0.12s ease;\n  z-index: var(--z-popup);\n"])), top, align);
};

exports.wrapper = wrapper;
exports.invisible = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  opacity: 0;\n  transform: scale(0.5);\n"])));